module.exports = __webpack_public_path__ + "img/r5.8536a55b.jpg";